export function formatFriendlyOpeningDatePhrase(isoString: string): string {
  const target = new Date(isoString);
  const now = new Date();

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const opening = new Date(target.getFullYear(), target.getMonth(), target.getDate());

  const millisPerDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.round((opening.getTime() - today.getTime()) / millisPerDay);

  const timeString = target
    .toLocaleTimeString('en-GB', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase();

  if (diffDays === 0) {
    return `Opens at ${timeString}`;
  }

  if (diffDays === 1) {
    return `Opens tomorrow at ${timeString}`;
  }

  if (diffDays > 1 && diffDays <= 6) {
    const weekday = target.toLocaleDateString('en-GB', { weekday: 'long' });
    return `Opens ${weekday} at ${timeString}`;
  }

  const longDate = target.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
  });

  return `Opens ${longDate} at ${timeString}`;
}

export function formatFriendlyClosingDatePhrase(isoString: string): string {
  const target = new Date(isoString);
  const timePhrase = target
    .toLocaleTimeString('en-GB', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
    .toLowerCase();

  return `Closes at ${timePhrase}`;
}

export function formatLongDate(isoString: string): string {
  const target = new Date(isoString);
  return target.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatHoursToReadableTime(hours: number): string {
  if (hours < 0) {
    return '0 hours';
  }

  const weeks = Math.floor(hours / 168);
  const remainingAfterWeeks = hours % 168;
  const days = Math.floor(remainingAfterWeeks / 24);
  const remainingHours = Math.floor(remainingAfterWeeks % 24);

  const parts: string[] = [];

  if (weeks > 0) {
    parts.push(`${weeks} ${weeks === 1 ? 'week' : 'weeks'}`);
  }

  if (days > 0) {
    parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
  }

  if (remainingHours > 0 || parts.length === 0) {
    parts.push(`${remainingHours} ${remainingHours === 1 ? 'hour' : 'hours'}`);
  }

  return parts.join(', ');
}
